import React from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";

type Props = {
  onlineColumns:columnTypes[];
  cashColumns: columnTypes[];
  withdrawl:(value:number)=>void;
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    setIsOpenInDialog: (newValue: boolean) => void;
    setIsOpenOutDialog: (newValue: boolean) => void;
    setIsOpenExchangeDialog: (newValue: boolean) => void;
  };
};

const DrawerAmountListing = ({
  onlineColumns,
  cashColumns,
  withdrawl,
  rows,
  paginationProps: {
    isTableLoading,
    setIsOpenInDialog,
    setIsOpenOutDialog,
    setIsOpenExchangeDialog
  },
}: Props) => {
  const navigate=useNavigate()
  const onlinePayments = (rows || []).filter((item: any) => item.type === "VIRTUAL");
  const cashDrawers = (rows || []).filter((item: any) => item.type==="PHYSICAL");

  const cashDrawerTotal = cashDrawers.reduce(
    (sum: any, item: any) => sum + Number(item.totalAmt || 0),
    0
  );

  const onlinePaymentsTotal = onlinePayments.reduce(
    (sum: any, item: any) => sum + Number(item.totalAmt || 0),
    0
  );

  const cashDrawerWithTotal = [
    ...cashDrawers,
    {
      _id: "cash-total-row",
      name: "Total",
      quantity: "",
      totalAmt: cashDrawerTotal,
      isTotalRow: true,
    },
  ];

  const onlinePaymentsWithTotal = [
    ...onlinePayments,
    {
      _id: "online-total-row",
      name: "Total",
      totalAmt: onlinePaymentsTotal,
      isTotalRow: true,
    },
  ];
  const totalAmount= cashDrawerTotal+onlinePaymentsTotal

  return (
    <SideNavLayout>
      <div className="p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
          moduleName="DRAWER"
            pageTitle="Drawers"
            hideSearchBox={true}
            buttonProps={{
              btnName: "Withdrawal All",
              onClick: () => {
                withdrawl(totalAmount)
              },
            }}
            extraButton={true}
            extraButtonProps={[
              {
                btnName: "Cash-In",
                onClick: () => {
                  navigate('/cash-in')
                },
              },
              {
                btnName: "Cash-Out",
                onClick: () => {
                  navigate('/cash-out')
                },
              },
              {
                btnName: "exchange",
                onClick: () => {
                  navigate('/cash-exchange')
                },
              },
            ]}
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
          {/* Cash Drawers */}
          <div className="border rounded shadow-sm p-4">
            <div className="text-xl font-medium text-slate-700 mb-4">
              Cash Drawers
            </div>
            <div className="overflow-auto">
              <ATMTable
                columns={cashColumns}
                rows={cashDrawerWithTotal}
                rowExtraClasses={(row) =>
                  row.isTotalRow ? "font-semibold bg-gray-100" : "min-h-[40px]"
                }
                isLoading={isTableLoading}
              />
            </div>
          </div>

          {/* Online Payments */}
          <div className="border rounded shadow-sm p-4">
            <div className="text-xl font-medium text-slate-700 mb-4">
              Online Payments
            </div>
            <div className="overflow-auto">
              <ATMTable
                columns={onlineColumns}
                rows={onlinePaymentsWithTotal}
                rowExtraClasses={(row) =>
                  row.isTotalRow ? "font-semibold bg-gray-100" : "min-h-[40px]"
                }
                isLoading={isTableLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

export default DrawerAmountListing;
